package sarka.design.skoria.ui.theme

import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.material3.ColorScheme
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import sarka.design.skoria.ui.theme.support.RCAccent
import sarka.design.skoria.ui.theme.support.RCAppShapes
import sarka.design.skoria.ui.theme.support.RCAppTypography
import sarka.design.skoria.ui.theme.support.RCBackground
import sarka.design.skoria.ui.theme.support.RCOnBackground
import sarka.design.skoria.ui.theme.support.RCOnPrimary
import sarka.design.skoria.ui.theme.support.RCOnPrimaryContainer
import sarka.design.skoria.ui.theme.support.RCOnSecondary
import sarka.design.skoria.ui.theme.support.RCOnSecondaryContainer
import sarka.design.skoria.ui.theme.support.RCOnSurface
import sarka.design.skoria.ui.theme.support.RCOnSurfaceVariant
import sarka.design.skoria.ui.theme.support.RCPrimary
import sarka.design.skoria.ui.theme.support.RCPrimaryContainer
import sarka.design.skoria.ui.theme.support.RCSecondary
import sarka.design.skoria.ui.theme.support.RCSecondaryContainer
import sarka.design.skoria.ui.theme.support.RCSurface
import sarka.design.skoria.ui.theme.support.RCTertiary

private val LightColors = lightColorScheme(
    primary = RCPrimary,
    onPrimary = RCOnPrimary,
    primaryContainer = RCPrimaryContainer,
    onPrimaryContainer = RCOnPrimaryContainer,

    secondary = RCSecondary,
    onSecondary = RCOnSecondary,
    secondaryContainer = RCSecondaryContainer,
    onSecondaryContainer = RCOnSecondaryContainer,

    tertiary = RCTertiary,

    background = RCBackground,
    surface = RCSurface,
    onBackground = RCOnBackground,
    onSurface = RCOnSurface,
    surfaceVariant = RCSurface,
    onSurfaceVariant = RCOnSurfaceVariant,
    surfaceContainer = RCSurface,
    surfaceContainerHighest = RCSurface,
    scrim = RCAccent,
)

private val DarkColors = darkColorScheme(
    primary = RCPrimary,
    onPrimary = RCOnPrimary,
    primaryContainer = RCPrimaryContainer,
    onPrimaryContainer = RCOnPrimaryContainer,

    secondary = RCSecondary,
    onSecondary = RCOnSecondary,
    secondaryContainer = RCSecondaryContainer,
    onSecondaryContainer = RCOnSecondaryContainer,

    tertiary = RCTertiary,

    background = RCBackground,
    surface = RCSurface,
    onBackground = RCOnBackground,
    onSurface = RCOnSurface,
    surfaceVariant = RCSurface,
    onSurfaceVariant = RCOnSurfaceVariant,
    surfaceContainer = RCSurface,
    surfaceContainerHighest = RCSurface,
    scrim = RCAccent,
)

@Composable
fun RCTheme(
    darkTheme: Boolean = isSystemInDarkTheme(),
    content: @Composable () -> Unit
) {
    val colors = if (darkTheme) DarkColors else LightColors

    MaterialTheme(
        colorScheme = colors,
        typography = RCAppTypography,
        shapes = RCAppShapes,
        content = content
    )
}

object RCTheme {
    val colors: ColorScheme
        @Composable get() = MaterialTheme.colorScheme
}
